<div class="ng-select-wrapper {{componentDefinition?.mandatory ? 'mandatory' : ''}}"
     [ngClass]="{'related-document-disable-link': !disableLink, 'related-document-disabled' : disabled,
      'related-document-is-not-empty-field' : !!fieldValue && fieldValue?.length !== 0, 'ng-select-not-fullwidth': !componentDefinition?.fullWidth }">
  <ng-select #ngSelectRelatedDocument
             [items]="results"
             [loading]="loading"
             [virtualScroll]="true"
             [typeahead]="typeahead"
             [required]="true"
             bindLabel="name"
             [multiple]="true"
             [maxSelectedItems]="maxSelectedItems"
             [hideSelected]="uniqueSelection"
             (blur)="outHidePanel()"
             (focus)="inShowPanel()"
             (click)="onClick($event)"
             [closeOnSelect]="true"
             [clearSearchOnAdd]="true"
             (add)="onChange($event, false)"
             [placeholder]="componentDefinition?.label"
             [formControl]="formControl"
             title="{{ fieldValue ? '' : componentDefinition?.label }}"
             [readonly]="disabled"
             (remove)="onRemove($event, ngSelectRelatedDocument)"
             [isOpen]="isOpened"
             (close)="dropDownClose()"
             (clear)="onClearAll()">
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <span *ngIf="item && item.name" title="{{item.name}}">{{ item.name }} </span>
      <span *ngIf="item && !item.name && item.systemHeader"
            title="{{ item.systemHeader.summaryName ?item.systemHeader.summaryName : 'Document ' + item.documentId }}">
            {{ item.systemHeader.summaryName ?item.systemHeader.summaryName : 'Document ' + item.documentId }}
      </span>
    </ng-template>
    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
      <span *ngIf="!disabled"  #ngSelectClearElem aria-hidden="true" class="ng-value-icon left" (click)="clearSelectedItem(ngSelectClearElem, clear, item)">×</span>
      <a *ngIf="!disableLink" (click)="openLink(item,$event,ngSelectRelatedDocument)"
         class="ng-select-link" title="{{loadItemName(item)}}"
         href="{{getRelUrlLink(item)}}">{{loadItemName(item)}}</a>
      <span *ngIf="disableLink" (click)="preventDropdown(ngSelectRelatedDocument)" class="ng-value-label"
            ng-reflect-escape="true">
        {{loadItemName(item)}}</span>
    </ng-template>
  </ng-select>
  <span *ngIf="componentDefinition?.newTemplate" class="spanNewTemplateCls">
      <button type="button" mat-button class="mat-button hidden-print"
              title="Add {{componentDefinition?.label}}"
              [disabled]="false" (click)="showTemplateDialog()">
          <i class="material-icons">library_add</i>
      </button>
  </span>
</div>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
